import React from "react";

export default function ImageSlider({ images }) {
  if (!images || images.length === 0) {
    return <div>No images available</div>;
  }

  return (
    <div className="image-slider">
      {images.map((img, index) => (
        <img
          key={index}
          src={img.url || img}
          alt={`Slide ${index + 1}`}
          style={{ width: "200px", marginRight: "10px" }}
        />
      ))}
    </div>
  );
}
